// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartBackgroundColorSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * ChartBackgroundColorSettings Component
 */
!(function() {
  var React = require('react');
  var m = require('mobx');
  var UIConstants = require('logic/data/Izenda.UIConstants');
  var ChartSettingsContainer = require('./Izenda.ChartSettingsContainer');
  var ENTIRE_CHART_MODE = 'entireChart';
  var PLOT_AREA_MODE = 'plotArea';
  var localizer = require('share/localization/Izenda.Localizer');

  var ChartBackgroundColorSettings = React.createClass({
    /**
     * Get inittial state
     */
    getInitialState: function() {
      var props = this.props;
      this.allChartProps = m.toJS(props.allChartProps);
      var value = (props && props.value) || {};
      return {
        backgroundColor:
          value['izEntire.backgroundColor'] || value['izPlot.backgroundColor'] || UIConstants.backgroundColor,
        appliedTo: value['izPlot.backgroundColor'] ? PLOT_AREA_MODE : ENTIRE_CHART_MODE
      };
    },

    /**
     * Handle changed value of background color setting compponent
     * @param  {object} schemaData schema data
     */
    onChangeValue: function(
      schemaData: Object,
      changedKey: any,
      changedKeyPath: any,
      changedValue: any,
      changedOthersInfo: any
    ) {
      const groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      const fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      this.setState({
        backgroundColor: schemaData.backgroundColor.value,
        appliedTo: schemaData.appliedTo.value
      });
    },

    /**
     * Get value of background color component
     */
    getValue: function() {
      var state = this.state;
      var isAppliedEntire = this.checkAppliedToMode(this.state.appliedTo);
      return {
        'izEntire.backgroundColor': isAppliedEntire ? state.backgroundColor : null,
        'izPlot.backgroundColor': isAppliedEntire ? null : state.backgroundColor
      };
    },

    /**
     * Check background color setting for entire or plot
     * @param  {string} value
     */
    checkAppliedToMode: function(value) {
      return value === ENTIRE_CHART_MODE;
    },

    /**
     * Render background color setting component
     * @return {Object}  react component
     */
    render: function() {
      var state = this.state;
      var isAppliedEntire = this.checkAppliedToMode(this.state.appliedTo);
      this.allChartProps = this.allChartProps;

      var chartOptions = {
        commonOptions: {
          'izEntire.backgroundColor': isAppliedEntire ? state.backgroundColor : null,
          'izPlot.backgroundColor': isAppliedEntire ? null : state.backgroundColor
        }
      };

      var configurationDef = {
        definedSchema: getSchema.bind(this)(),
        source: state,
        onChangeValue: this.onChangeValue
      };

      return (
        <ChartSettingsContainer
          type={this.props.reportPartType}
          configurationDef={configurationDef}
          chartOptions={chartOptions}
          allChartProps={this.allChartProps}
        />
      );

      /**
       * Define background color component schema
       * @return {object} background component schema
       */
      function getSchema() {
        return {
          schemaKey: 'BACKGROUND_COLOR_SCHEMA',
          fields: {
            // color
            backgroundColor: {
              title: localizer.getText('COMMON_LABEL_COLOR'),
              type: 'color'
            },
            // applied to
            appliedTo: {
              title: localizer.getText('REPORTDESIGNER_TOOLTIP_APPLIED_TO'),
              component: require('share/components/controls/Izenda.GroupRadioInput'),
              value: this.state.appliedTo,
              props: {
                options: [
                  { label: localizer.getText('REPORTDESIGNER_LABEL_ENTIRE_CHART'), value: ENTIRE_CHART_MODE },
                  { label: localizer.getText('REPORTDESIGNER_LABEL_PLOT_AREA'), value: PLOT_AREA_MODE }
                ]
              }
            }
          }
        };
      }
    }
  });

  module.exports = ChartBackgroundColorSettings;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ChartBackgroundColorSettings.jsx